import {serverApi} from '../../api/serverAPI'

const datas = {

    getMembers: (args) => new Promise((resolve, reject) => {
        console.log(args)
     
        serverApi.get('/mailchimp/members',{ params:args})
        .then(function (response) {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    }),
    
    getMember: (args) => new Promise((resolve, reject) => {
      console.log(args)
     
        serverApi.get('/mailchimp/members/'+args)
        .then(function (response) {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    }),
    getSegments: (args) => new Promise((resolve, reject) => {
        console.log(args)
       
          serverApi.get('/mailchimp/members/segments/1')
          .then(function (response) {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
      ,
    getCampaigns: (args) => new Promise((resolve, reject) => {
        console.log(args)
       
          serverApi.get('/mailchimp/campaigns',{ params:args})
          .then(function (response) {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
      ,
      getAutomations: (args) => new Promise((resolve, reject) => {
          console.log(args)
         
            serverApi.get('/mailchimp/automations',{ params:args})
            .then(function (response) {
              resolve(response)
            })
            .catch((error) => {
              reject(error)
            })
        }),
        getStores: (args) => new Promise((resolve, reject) => {
          console.log(args)
         
            serverApi.get('/mailchimp/ecommerce',{ params:args})
            .then(function (response) {
              resolve(response)
            })
            .catch((error) => {
              reject(error)
            })
        })
        ,
        getProducts: (args) => new Promise((resolve, reject) => {
          console.log('args',args)
         
            serverApi.get('/mailchimp/ecommerce/products',{ params:args})
            .then(function (response) {
              resolve(response)
            })
            .catch((error) => {
              reject(error)
            })
        }),
        getTasterSignups: (args) => new Promise((resolve, reject) => {
  
         
            serverApi.get('mailchimp/audience/taster/signups')
            .then(function (response) {
              resolve(response)
            })
            .catch((error) => {
              reject(error)
            })
        })
        ,
        getBrochureSignups: (args) => new Promise((resolve, reject) => {
  
         
            serverApi.get('mailchimp/audience/brochure/signups')
            .then(function (response) {
              resolve(response)
            })
            .catch((error) => {
              reject(error)
            })
        })
}
export default datas


// WEBPACK FOOTER //
// ./src/components/Mailchimp/api.js